import * as React from 'react';

import logo from 'assets/images/jpg/logo-ministere.jpg';

function LogoMinistere(): React.ReactElement {
  return <img src={logo} alt="Logo du ministère" />;
}

export default LogoMinistere;
